import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ShieldCheckIcon, FilterIcon, CalculatorIcon } from 'lucide-react';
const features = [{
  icon: CalendarIcon,
  title: 'Plan 30 Días',
  description: 'Calendario exacto de dominio financiero paso a paso.'
}, {
  icon: ShieldCheckIcon,
  title: 'Estrategia Renta Segura',
  description: 'Cero estrés a fin de mes. Tu renta siempre cubierta.'
}, {
  icon: FilterIcon,
  title: 'Filtro Anti-Deuda',
  description: 'Elimina saldos pendientes sin dolor ni sacrificio extremo.'
}, {
  icon: CalculatorIcon,
  title: 'Calculadora de Efectivo',
  description: 'Descubre el dinero oculto en tus gastos diarios.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FeaturesSection() {
  return <section className="py-20 md:py-28 bg-light overflow-hidden" data-id="element-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-7">
          {/* Left Column: 3D Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 flex justify-center perspective-1000" data-id="element-8">
            <div className="relative w-72 md:w-80 h-[400px] md:h-[450px] transform-style-3d transition-transform duration-700 hover:rotate-y-[-5deg] rotate-y-[-15deg] rotate-x-[5deg]" data-id="element-9">
              {/* Book Spine */}
              <div className="absolute left-0 top-0 bottom-0 w-8 bg-navy-light transform -translate-x-4 translate-z-[-16px] rotate-y-[-90deg] rounded-l-sm shadow-inner" data-id="element-10" />

              {/* Book Cover */}
              <div className="absolute inset-0 bg-navy rounded-r-xl rounded-l-sm shadow-2xl flex flex-col items-center justify-center p-8 text-center border-l border-white/10 overflow-hidden" data-id="element-11">
                {/* Decorative Elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-500/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-12" />
                <div className="absolute bottom-0 left-0 w-40 h-40 bg-navy-light/50 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2" data-id="element-13" />

                <div className="relative z-10 w-full" data-id="element-14">
                  <div className="w-16 h-1 bg-emerald-500 mx-auto mb-8" data-id="element-15" />
                  <h3 className="font-serif text-3xl md:text-4xl text-white leading-tight mb-4 tracking-wide" data-id="element-16">
                    PROTOCOLO
                    <br data-id="element-17" />
                    DEUDA
                    <br data-id="element-18" />
                    CERO
                  </h3>
                  <p className="text-emerald-400 font-sans text-sm tracking-widest uppercase mt-8" data-id="element-19">
                    Guía de Choque
                  </p>
                </div>
              </div>

              {/* Book Pages (Right Edge) */}
              <div className="absolute right-0 top-2 bottom-2 w-4 bg-white/90 transform translate-x-2 translate-z-[-8px] rotate-y-[90deg] rounded-r-sm shadow-inner" data-id="element-20" />
            </div>
          </motion.div>

          {/* Right Column: Features List */}
          <div className="w-full lg:w-1/2" data-id="element-21">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} data-id="element-22">
              <h2 className="font-serif text-3xl md:text-4xl text-navy mb-12" data-id="element-23">
                ¿Qué incluye tu Guía de Choque?
              </h2>
            </motion.div>

            <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-100px'
          }} className="space-y-8" data-id="element-24">
              {features.map((feature, index) => {
              const Icon = feature.icon;
              return <motion.div key={index} variants={itemVariants} className="flex gap-6" data-id="element-25">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-emerald-500/10 flex items-center justify-center mt-1" data-id="element-26">
                      <Icon className="w-6 h-6 text-emerald-600" data-id="element-27" />
                    </div>
                    <div data-id="element-28">
                      <h3 className="font-sans text-xl font-bold text-navy mb-2" data-id="element-29">
                        {feature.title}
                      </h3>
                      <p className="font-sans text-muted leading-relaxed" data-id="element-30">
                        {feature.description}
                      </p>
                    </div>
                  </motion.div>;
            })}
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}